import { Slate } from "@makeswift/controls";
const BlockType = Slate.BlockType;
const InlineType = Slate.InlineType;
export {
  BlockType,
  InlineType
};
//# sourceMappingURL=types.js.map